export const GTM_CONTAINER_ID = "GTM-W8S6J2NK";
export const GTM_PAGE_VIEW_EVENT = "page_view";

const ensureDataLayer = () => {
  window.dataLayer = window.dataLayer || [];
  return window.dataLayer;
};

export const pushGtmEvent = (event, payload = {}) => {
  ensureDataLayer().push({
    event,
    ...payload,
  });
};

export const pushGtmPageView = (route) => {
  const pageName = route.meta?.title || route.name || route.path;

  pushGtmEvent(GTM_PAGE_VIEW_EVENT, {
    page_name: pageName,
    page_path: route.path,
    page_title: document.title,
    page_location: window.location.href,
  });
};
